module.exports = __webpack_public_path__ + "static/img/android2.df00a42a.jpg";